import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const incidentReportsRequest = createRequest(constants.incidentReports);
export const incidentReportsSuccess = createSuccess(constants.incidentReports);
export const incidentReportsFailure = createFailure(constants.incidentReports);
export const requestIncidentReports = incidentReportsRequest;

export const createIncidentReportRequest = createRequest(constants.createIncidentReport);
export const createIncidentReportSuccess = createSuccess(constants.createIncidentReport);
export const createIncidentReportFailure = createFailure(constants.createIncidentReport);
export const createIncidentReport = createIncidentReportRequest;

export const updateIncidentReportRequest = createRequest(constants.updateIncidentReport);
export const updateIncidentReportSuccess = createSuccess(constants.updateIncidentReport);
export const updateIncidentReportFailure = createFailure(constants.updateIncidentReport);
export const updateIncidentReport = updateIncidentReportRequest;

export const deleteIncidentReportRequest = createRequest(constants.deleteIncidentReport);
export const deleteIncidentReportSuccess = createSuccess(constants.deleteIncidentReport);
export const deleteIncidentReportFailure = createFailure(constants.deleteIncidentReport);
export const deleteIncidentReport = deleteIncidentReportRequest;

export const pendingIncidentReportRequest = createRequest(constants.pendingIncidentReport);
export const pendingIncidentReportSuccess = createSuccess(constants.pendingIncidentReport);
export const pendingIncidentReportFailure = createFailure(constants.pendingIncidentReport);
export const pendingIncidentReport = pendingIncidentReportRequest;

export const approveIncidentReportRequest = createRequest(constants.approveIncidentReport);
export const approveIncidentReportSuccess = createSuccess(constants.approveIncidentReport);
export const approveIncidentReportFailure = createFailure(constants.approveIncidentReport);
export const approveIncidentReport = approveIncidentReportRequest;

export const incidentReportRequest = createRequest(constants.incidentReport);
export const incidentReportSuccess = createSuccess(constants.incidentReport);
export const incidentReportFailure = createFailure(constants.incidentReport);
export const requestIncidentReport = incidentReportRequest;

export const incidentReportLinkRequest = createRequest(constants.reportLink);
export const incidentReportLinkSuccess = createSuccess(constants.reportLink);
export const incidentReportLinkFailure = createFailure(constants.reportLink);
export const requestIncidentReportLink = incidentReportLinkRequest;
